import { ISortable } from '../../interfaces/sortable.interface';
import { RestApiAction } from '../actions/rest-api-action';
import { RestApiCondition } from '../conditions/rest-api-condition';

export class RestApiEventConfiguration implements ISortable {
    public id: number | null = null;
    public name: string = null;
    public description: string = null;
    public conditions: RestApiCondition[] = [];
    public actions: RestApiAction[] = [];
    public order: number;

    public createCopy(): RestApiEventConfiguration {
        const instance = new RestApiEventConfiguration();
        instance.id = this.id;
        instance.name = this.name;
        instance.description = this.description;
        instance.conditions = RestApiCondition.cloneArray(this.conditions);
        instance.actions = RestApiAction.cloneArray(this.actions);
        instance.order = this.order;

        return instance;
    }
    public copyFrom(other: any) {
        this.id = other.id;
        this.name = other.name;
        this.description = other.description;
        this.conditions = RestApiCondition.cloneArray(other.conditions);
        this.actions = RestApiAction.cloneArray(other.actions);
        this.order = other.order;
    }

    /**
     * Retourne une copie d'une instance de RestApiEventConfiguration
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: RestApiEventConfiguration) {
        if (!!other) {
            const instance = new RestApiEventConfiguration();

            instance.id = other.id;
            instance.name = other.name;
            instance.description = other.description;
            instance.conditions = RestApiCondition.cloneArray(other.conditions);
            instance.actions = RestApiAction.cloneArray(other.actions);
            instance.order = other.order;

            return instance;
        } else {
            return null;
        }
    }

    /**
     * Retourne une copie d'un tableau d'instances de RestApiResponseVariableConfiguration
     * @param other : Tableau source.
     * @returns : Copie du tableau.
     */
    public static cloneArray(others: RestApiEventConfiguration[]) {
        if (!!others) {
            let events: RestApiEventConfiguration[] = [];

            others.forEach((x) => {
                const event = RestApiEventConfiguration.clone(x);
                events.push(event);
            });

            return events;
        } else {
            return [];
        }
    }
}
